import tippy, { animateFill, roundArrow, followCursor } from 'tippy.js';

const config = {
  animation: 'fade',
  appendTo: 'parent',
  arrow: false,
  delay: 100,
  duration: 100,
  hideOnClick: true,
  interactive: true,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  maxWidth: 350,
  moveTransition: 'transform 0.2s ease-out',
  offset: [0, 6],
  placement: 'bottom',
  popperOptions: {},
  theme: '',
  touch: true,
  trigger: 'mouseenter focus click',
  zIndex: 91,
  allowHTML: true,
};

class CTooltips {
  constructor() {
    this.config = Object.assign({}, config);
    this.tippyConfig = this.config;

    this.wrapClass = '.b-tooltip';
    this.wrapTextClass = '.b-tooltip__text';
    this.tippyClass = '.b-tooltip__tippy';
    this.tippyContentClass = '.b-tooltip__content';
    this.tippyRegularClass = '.b-tooltip__tippy:not([data-tippy-theme]';
    this.tippyCustomClass = '.b-tooltip__tippy[data-tippy-theme="custom"]';

    this.tippySVGClass = '.b-tooltip-svg';

    this.regularInstances = [];
    this.customInstances = [];
    // this.svgInstances = [];
    this.modalInstences = [];

    this.allInstances = [];
    this.allTableFixedHeadInstances = [];
  }

  init() {
    this.createConfig();

    this.tippyRegular();
    this.tippyCustom();

    const svgElements = document.querySelectorAll(`${this.tippySVGClass}`);
    if (svgElements.length) {
      /* Deprecated: this.createSvgTippy(svgElements); */
      this.tippySvg();
    }

    this.allInstances.push(...this.regularInstances, ...this.customInstances);
  }

  // Общий конфиг для всех типпи
  createConfig() {
    const commonConfig = {
      content: (reference) => {
        const tooltipContentNode = reference.parentNode.querySelector('.b-tooltip__content');
        const tooltipContentCopy = tooltipContentNode ? tooltipContentNode.cloneNode(true) : '';

        return tooltipContentCopy || tooltipContentNode;
      },
      onShow: (instance) => this.onTippyShow(instance),
      plugins: [followCursor, animateFill],
    };

    this.tippyConfig = Object.assign({}, this.config, commonConfig);
  }

  // Отдельная настройка обычного типпи
  tippyRegular() {
    const regularConfig = {
      appendTo: () => document.body,
    };

    const instances = tippy(this.tippyRegularClass, Object.assign({}, this.tippyConfig, regularConfig));
    this.regularInstances = instances;
  }

  // Отдельная настройка обычного типпи
  tippyCustom() {
    const customConfig = {
      arrow: roundArrow,
    };

    const instances = tippy(this.tippyCustomClass, Object.assign({}, this.tippyConfig, customConfig));
    this.customInstances = instances;
  }

  // Создание типпи для свг /* Kill */
  createSvgTippy(svgElements) {
    const tooltipsInSvg = [];

    // Проходимся по всех свг элементам, добавляем в массив все тултипы из всех свг элеметов
    svgElements.forEach((elem) => {
      const svgTooltips = elem.querySelectorAll(this.wrapClass);
      tooltipsInSvg.push(...svgTooltips);
    });

    // Создаем иконку на месте тултипа.
    if (tooltipsInSvg.length) {
      tooltipsInSvg.forEach((elem) => {
        this.createSVGTooltipIcon(elem);
      });
    }

    // Иконка сильно меняет структуру свг (читай readme: createSVGTooltipIcon), поэтому еще раз проходимся по всем свг элементам, находим новые элементы с классом тултипа и навешиваем логику tippy на них
    svgElements.forEach((elem) => {
      const svgTooltips = elem.querySelectorAll(this.tippyRegularClass);

      if (svgTooltips) {
        this.tippySvg(svgTooltips);
      }
    });
  }

  // Создание иконки в свг (описана в readme: createSVGTooltipIcon)
  createSVGTooltipIcon(tooltip) {
    const textElement = tooltip.parentNode;
    const copyTextElement = tooltip.cloneNode(true);

    tooltip.classList.remove('b-tooltip');
    tooltip.classList.add('tooltip-space');
    tooltip.innerHTML = '00';

    const textContent = textElement.innerHTML.trim();

    const groupElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    const newTextElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    const foreignObjectElement = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');

    for (const attr of textElement.attributes) {
      groupElement.setAttribute(attr.name, attr.value);
    }

    newTextElement.innerHTML = textContent;

    const tooltipXCoord = tooltip.getBBox().x;
    const tooltipYCoord = tooltip.getBBox().y;

    foreignObjectElement.setAttribute('height', '5');
    foreignObjectElement.setAttribute('width', '5');
    foreignObjectElement.setAttribute('x', tooltipXCoord);
    foreignObjectElement.setAttribute('y', tooltipYCoord);

    const svgLinks = copyTextElement.querySelectorAll('a');
    svgLinks.forEach((link) => {
      const href = link.getAttribute('xlink:href');
      link.removeAttribute('xlink:href');
      link.setAttribute('href', href);
    });

    const tooltipHTML = `
        <span class="${this.wrapClass.slice(1)}">
            <span class="${this.tippyClass.slice(1)}"></span>
            <span class="${this.tippyContentClass.slice(1)}">${copyTextElement.innerHTML}</span>
        </span>
    `.replace(/\n\s*/g, '');

    foreignObjectElement.innerHTML = tooltipHTML;

    groupElement.appendChild(newTextElement);
    groupElement.appendChild(foreignObjectElement);
    textElement.replaceWith(groupElement);
  }

  // Отдельная настройка типпи в svg
  tippySvg(elements) {
    const svgConfig = {
      appendTo: () => document.body,
      content(reference) {
        const id = reference.getAttribute('data-content');
        const template = document.getElementById(id);
        return template?.innerHTML || 'Empty';
      },
    };

    const instances = tippy(this.tippySVGClass, Object.assign({}, this.tippyConfig, svgConfig));
    // this.svgInstances = instances;
    this.allInstances.push(...instances);
  }

  // Отдельная настройка типпи в модалках
  createModalInstances(modalWindow) {
    if (!modalWindow) {
      return;
    }

    const tableTooltips = [
      ...modalWindow.querySelectorAll('.b-table__content tbody .b-tooltip__tippy'),
      ...modalWindow.querySelectorAll('.b-table__fixed .b-tooltip__tippy'),
    ];
    const svgTooltips = modalWindow.querySelectorAll('.b-tooltip-svg.js-tooltip');
    const captionTooltips = modalWindow.querySelectorAll('.graphic figcaption .b-tooltip__tippy');

    const modalConfig = {
      appendTo: modalWindow,
    };

    if (tableTooltips.length) {
      const instances = tippy(tableTooltips, Object.assign({}, this.tippyConfig, modalConfig));
      this.modalInstences.push(...instances);
    }
    if (captionTooltips.length) {
      const instances = tippy(captionTooltips, Object.assign({}, this.tippyConfig, modalConfig));
      this.modalInstences.push(...instances);
    }
    if (svgTooltips.length) {
      const instances = tippy(
        svgTooltips,
        Object.assign({}, this.tippyConfig, modalConfig, {
          content(reference) {
            const id = reference.getAttribute('data-content');
            const template = document.getElementById(id);
            return template?.innerHTML || 'Empty';
          },
        }),
      );
      this.modalInstences.push(...instances);
    }
  }

  // Отдельная настройка типпи в фикс шапке таблиц
  createTableFixedHeadInstances(elements) {
    const tableFixedHeadConfig = {};

    const instances = tippy(elements, Object.assign({}, this.tippyConfig, tableFixedHeadConfig));

    this.allTableFixedHeadInstances = instances;
  }

  // Удаление инстансов у типпи после закрытия модалки
  destroyModalInstances() {
    if (this.modalInstences.length) {
      this.modalInstences.forEach((instance) => instance.destroy());
      this.modalInstences = [];
    }
  }

  // Удаление инстансов у типпи после закрытия фикс шапки
  hideTableFixedHeadInstances() {
    this.allTableFixedHeadInstances.forEach((instance) => this.hide(instance));
  }

  // Эмиттер, возможность смотреть на типпи сразу после показа
  onTippyShow(instance) {
    // AR.events.emit('tooltipShown', instance);
  }

  // Достать инстанс по ноде
  getInstance(node) {
    const nodeTippy = node.querySelector(this.tippyClass);
    const tooltipInstance = this.allInstances.find((instance) => instance.reference === nodeTippy);
    return tooltipInstance;
  }

  // Создать тултип на месте ноды
  createTooltipInsideNode(node, text, config = {}) {
    const tooltipHTML = `
        <span class="${this.wrapClass.slice(1)}"><span class="${this.wrapTextClass.slice(1)}">${node.textContent}</span>
            <span class="${this.tippyClass.slice(1)}"></span>
            <span class="${this.tippyContentClass.slice(1)}">${text}</span>
        </span>
    `.replace(/\n\s*/g, '');

    const tempElement = document.createElement('div');
    tempElement.innerHTML = tooltipHTML;
    const tooltipElement = tempElement.querySelector('.b-tooltip');
    node.parentNode.replaceChild(tooltipElement, node);

    const instance = tippy(tooltipElement.querySelector(this.tippyClass), this.tippyConfig, config);
    this.allInstances.push(instance);
  }

  //
  // Далее все методы из библиотеки типпи (https://atomiks.github.io/tippyjs/v6/methods/)
  //

  destroy(instance) {
    instance.destroy();
  }

  hide(instance) {
    instance.hide();
  }

  show(instance) {
    instance.show();
  }

  disable(instance) {
    instance.disable();
  }

  enable(instance) {
    instance.enable();
  }

  setProps(elements) {
    const instance = this.createInstances(elements);

    instance.setProps({
      arrow: true,
      animation: 'scale',
    });
  }

  setContent(instance, text) {
    instance.setContent(text);
  }

  unmount(instance) {
    instance.unmount();
  }

  clearDelayTimeouts(instance) {
    instance.clearDelayTimeouts();
  }
}

if (document.body.classList.contains('body--armax')) {
  const cTooltips = new CTooltips();
  const tooltips = document.querySelectorAll('.js-tooltip');

  tooltips.forEach((tooltip, i) => {
    cTooltips.init(tooltip, i);
  });
}
